import { render, staticRenderFns } from "./job_fair_new.vue?vue&type=template&id=d6244d0c&scoped=true"
import script from "./job_fair_new.vue?vue&type=script&lang=js"
export * from "./job_fair_new.vue?vue&type=script&lang=js"
import style0 from "./job_fair_new.vue?vue&type=style&index=0&id=d6244d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6244d0c",
  null
  
)

export default component.exports